import React from 'react'
import Helmet from 'react-helmet'
import Layout from '../components/layout'
import BannerLanding from '../components/BannerLanding'
import GalleryComponent from '../components/Gallery'

const IrrigationSystem = (props) => (
  <Layout>
    <Helmet>
      <title>Natural Grass</title>
      <meta
        name="description"
        content="Renew Your Garden Lawn Into An Exciting Space."
      />
    </Helmet>
    <BannerLanding
      title="Natural grass"
      descript="Renew Your Garden Lawn Into An Exciting Space."
    />
    <div id="main">
      <section id="one">
        <div className="inner" style={{ overflow: 'hidden' }}>
          <header className="major">
            <h2>Take a look of our work</h2>
          </header>
          <GalleryComponent type="natural" />
        </div>
      </section>
    </div>
  </Layout>
)

export default IrrigationSystem
